export default {
  "l10n": {
    "date": {
      "months": {
        "full": ["janvier","février","mars","avril","mai","juin","juillet","août","septembre","octobre","novembre","décembre"],
        "abbr": ["janv.","févr.","mars","avr.","mai","juin","juil.","août","sept.","oct.","nov.","déc."]
      },
      "days": {
        "full": ["dimanche","lundi","mardi","mercredi","jeudi","vendredi","samedi"],
        "abbr": ["dim.","lun.","mar.","mer.","jeu.","ven.","sam."]
      },
      "patterns": {
        "longtime": "HH:mm:ss",
        "birthdate": "dd/MM/yyyy",
        "shorttime": "HH:mm",
        "shortdate": "dd/MM HH:mm",
        "shortday": "dd MMM",
        "fulldate": "dd/MM/yyyy HH:mm"
      }
    },
    "number": {
      "patterns": {
        "standard": ["-n", "n"],
        "amount": ["-n S", "n S"],
        "blinds": "s-b S"
      },
      "group": {
        "separator": " ",
        "length": 3,
        "abbr": ["", "k", "M", "Md"]
      },
      "decimal": {
        "separator": ",",
        "length": 2
      },
      "ordinal": function (number) { return number + (number === 1 ? 'er' : 'e'); }
    }
  },
  "translations": {
    messages: {
  "Challenges": [
    null,
    "Challenges"
  ],
  "Close": [
    null,
    "Fermer"
  ],
  "Guarantee": [
    null,
    "Dotation"
  ],
  "Name": [
    null,
    "Nom"
  ],
  "Next level": [
    null,
    "Prochain palier"
  ],
  "No data": [
    null,
    "Aucune information"
  ],
  "Points": [
    null,
    "Points"
  ],
  "Potential winnings": [
    null,
    "Gains potentiels"
  ],
  "Rank": [
    null,
    "Position"
  ],
  "to be shared out every day!": [
    null,
    "à se partager chaque jour !"
  ]
}
  }
}
